import { instance } from '../../requests/axios.instance';

/**
 * Les métiers de la société, pour le choix du métier d'un modèle de site.
 *
 *   GET /company_works → { works: ["cleaning", "guarding"] }
 *
 * À ne pas confondre avec le `works` de `GET /user`, qui ne rend que **les
 * métiers du demandeur ayant `option_editor`**. Ici la liste est celle de la
 * société entière, y compris les métiers qu'il n'exerce pas : une liste plus
 * étroite que la validation qu'elle alimente bloquerait l'administrateur là où
 * le back l'autorise — or c'est lui qui doit corriger les modèles que le
 * backfill a rattachés au premier métier de leur société.
 *
 * Réservé côté back à qui peut écrire un modèle de site (`setup_editor` ou
 * `superadmin`) — exactement la garde de l'écran qui l'appelle, donc jamais de
 * 401 en usage normal.
 */
export async function fetchCompanyWorks() {
  const res = await instance.get('/company_works');
  if (res.status !== 200) throw new Error(`GET company works status code ${res.status}`);
  return Array.isArray(res.data?.works) ? res.data.works : [];
}

export default fetchCompanyWorks;
